<template lang="pug">

main
  section.intro
    .card.feature
      ad-giveaway
    .card.feature.featured2
      ad-featured
  br
  button(v-if="isAuthenticated" @click="showAddDealModal = true") Add Deal
  br
  isotope(ref="cpt" id="root_isotope1" :item-selector="'element-item'" :list="deals" :options='option' v-images-loaded:on.progress="layout" @filter="filterOption=arguments[0]")
    bems-event-card(v-if="deal.status === 'live'" v-for="deal in deals" key="deal['.key']" :thekey="deal.provider" :name="deal.title" :description="deal.desc" :img="deal.image")
  search-n-filter
    p Categories:
    select(@change="filter(selectedCat)" v-model="selectedCat")
      option(value='' selected) Select a Category
      option(v-for="(val, key) in option.getFilterData", :value="key") {{key}}
  add-deal(@closedAddDealModal="showAddDealModal = false" v-if="showAddDealModal === true")

</template>

<script>

import bemsEventCard from './bems-event-card.vue'
import adFeatured from '@/components/ad-featured.vue'
import adGiveaway from '@/components/ad-giveaway.vue'
import searchNFilter from '@/components/search-n-filter'
import addDeal from '@/components/add-deal-modal'

import imagesLoaded from 'vue-images-loaded'
import isotope from 'vueisotope'

export default {
  name: 'coupons',
  data() {
    return {
      currentLayout: 'masonry',
      selected: null,
      sortOption: 'original-order',
      filterOption: 'show all',
      showAddDealModal: false,
      selectedCat: '',
      option: {
        itemSelector: '.element-item',
        getFilterData: {
          'show all': function () {
            return true
          },
          contractors: function (el) {
            return el.cat === 'Contractors'
          },
          diamond: function (el) {
            return el.tier === '1'
          },
          food: function (el) {
            return el.cat === 'Restaurants' || el.cat === 'Catering'
          }
        }
      }
    }
  },
  components: {
    bemsEventCard,
    isotope,
    adFeatured,
    adGiveaway,
    searchNFilter,
    addDeal
  },
  directives: {
    imagesLoaded
  },
  created() {
    this.$store.dispatch('loadedDeals')
  },
  methods: {
    filter(key) {
      this.$refs.cpt.filter(key)
    },
    layout() {
      this.$refs.cpt.layout('masonry')
    }
  },
  computed: {
    deals() {
      return this.$store.getters.deals
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    }
  }
}
</script>

<style lang="stylus">
button {
  max-width: 200px;
  height: 40px;
  background-color: teal;
  color: white;
  border: none;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

.deal-container {
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 350px;
  min-width: 350px;
  background: #333;
  overflow: hidden;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.25);
  margin-left: 2em;
}

.deal-title-container {
  background: linear-gradient(#555, #333);
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50px;
}

.deal-detail {
  color: #ddd;
  padding: 0.5em;
  line-height: 1.5;
  font-size: 1.5vh;
}

.deal-img-wrapper {
  margin-bottom: 2px;
  border-bottom: 5px solid #555;
  border-top: 5px solid #555;
}

.deal-img-wrapper img {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.deal-button-wrapper.left {
  width: 100%;
}

.deal-button-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: linear-gradient(#555, #333);
  height: 50px;
  bottom: 0px;
  width: 100%;
  background-color: #555;
}
</style>
